import { Routes, RouterModule } from '@angular/router';
import { ModuleWithProviders } from '@angular/core';
// import { createComponent } from 'app/pages/createAccount';
import { AutoLoginComponent } from './autoLogin/autoLoginComponent';
import { ResetPassword } from './resetPassword/resetPassword.component';

export const routes: Routes = [
  { path: '', redirectTo: 'login', pathMatch: 'full' },
  { path: 'signup/:accesskey', component: AutoLoginComponent },
  { path: 'reset-password/:resetkey', component: ResetPassword },
  //{ path: '**', redirectTo: 'pages/masters/discover' }.
  // { path: '**', redirectTo: 'pages/masters/home' }
  // { path: '**', redirectTo: 'pages/masters/compare' }
];

export const routing: ModuleWithProviders = RouterModule.forRoot(routes, { useHash: true });



// WEBPACK FOOTER //
// ./src/app/app.routing.ts